import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import { SnapshotImageContract } from '@polaris-customerweb/sharedcomponents.core';
import { RoutingHelpersService } from '@polaris-customerweb/sharedcomponents.shared';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SnapshotResourceService {
    private baseUrl: string;

    constructor(
        configService: ConfigService,
        private http: HttpClient,
        private routingHelpersService: RoutingHelpersService
    ) {
        this.baseUrl = routingHelpersService.combineUrl(
            configService.apiUrl.rideCommand,
            'snapshot'
        );
    }

    getSnapshot(
        mapObject:
            | GeoJSON.Feature<
                  GeoJSON.Point | GeoJSON.Polygon | GeoJSON.LineString
              >
            | GeoJSON.FeatureCollection<GeoJSON.LineString | GeoJSON.Point>,
        mapId: string,
        width: number,
        height: number,
        style: 'plannedRide' | 'trackedRide' = 'plannedRide'
    ): Observable<SnapshotImageContract> {
        const url = this.routingHelpersService.combineUrl(
            this.baseUrl,
            mapId,
            `${width}x${height}`,
            style
        );
        return this.http.post<SnapshotImageContract>(url, mapObject);
    }
}
